export const COMMUNITY_REPOSITORY = "https://github.com/u2bo/OpenChatGPTSkin-Community";
export const COMMUNITY_SITE_ORIGIN = "https://u2bo.github.io/OpenChatGPTSkin-Community";
export const COMMUNITY_BASE_PATH = "/OpenChatGPTSkin-Community/";
export const CORE_REPOSITORY = "https://github.com/u2bo/OpenChatGPTSkin.git";
export const CORE_TOOLING_COMMIT = "04f0293371645c2d98880cd7d0572f9a9eb83380";
export const LOCAL_REVISION = "0000000000000000000000000000000000000000";
